module.exports = __webpack_public_path__ + "img/1722486035804-WhatsApp Image 2024-08-01 at 12.12.23.jpeg.845b30a0.webp";